import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../config/Config.js";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);

  const [emailerrormessage, setemailerrormessage] = useState("");
  const dispatch = useDispatch(); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    var isemailerror = false;

    // if (!formData.email) {
    //   alert("Email is required");
    //   return;
    // }
    if(formData.email) {
      if(validateEmail(formData.email)) {
        isemailerror = false;
        setemailerrormessage("");
      } else {
        isemailerror = true;
        setemailerrormessage("Invalid Email ID");
      }
    } else {
      isemailerror = true;
      setemailerrormessage("Email ID cannot be empty");
    }

    if(!isemailerror) {
      // alert('valid');
    } else {
      // alert('Invalid');
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        apiUrl + "usersendotp",
        {
          email: formData.email
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        // dispatch({ type: "customerdata", payload: res.data.data })
        // navigate("/createstory");
        const user = {
            email: formData.email,
        };
        navigate("/verify-otp", { state: user });
      } else {
        alert(res.data.message || "Something Went Wrong!!");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  return (


    <>
<Helmet>
  {/* Meta Title */}
  <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />

  {/* Primary Keywords */}
  <meta
    name="keywords"
    content="spiritual stories, spiritual tale, spiritual story telling platform"
  />

  {/* Canonical Tag */}
  <link rel="canonical" href="https://theomsaga.com/login" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Login to TheOmSaga | Share Your Spiritual Stories"
  />
  <meta
    property="og:description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />
  <meta property="og:url" content="https://theomsaga.com/login" />
  <meta
    property="og:image"
    content="https://theomsaga.com/assets/images/login-banner.webp"
  />

  {/* Schema Markup */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
  </script>
</Helmet>



<div className="login-page-container">
      <div className="login-page-scroll verifyotp-page-scroll forget-password-div">
        <div className="login-page-main-content">
          <div>
            <p className="login-page-title">FORGOT PASSWORD</p>
          </div>

          <form className="login-page-form" onSubmit={handleSubmit}>
            <input
              className="login-page-input"
              type="text"
              name="email"
              placeholder="Enter Email-ID *"
              value={formData.email}
              onChange={handleChange}
            />
            {
              emailerrormessage ?
              <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{emailerrormessage}</p>
                </div> : null
            }
            
            <button className="login-page-button" type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </form>

          <div className="login-page-mantra">
            <p>
            Haven’t registered yet?{" "}<br />
              <button
                type="button"
                className="login-page-registerlink"
                onClick={handleRegisterClick}
              >
                register now
              </button>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  
  );
};

export default ForgetPassword;
